export const OTA_STATUS_ENUMS = {
  // 准备中未开始
  PADDING: 0,
  // 进行中
  PROCESSING: 1,
  // 停止
  STOP: 2,
  // 成功
  SUCCESS: 3,
  // 升级失败
  UPDATE_FAILED: 4,
  // 取消失败
  CANCEL_FAILED: 5,
}


export const WIFI_STATUS_ENUMS = {
  //在线
  ONLINE:1,
  // 离线
  OFFLINE:0
}